export const SET_AUTH_DATA = 'SET_AUTH_DATA'

export const setAuthData = payload => ({
  type: SET_AUTH_DATA,
  payload,
})
